import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { lazy, Suspense } from "react";
import Header from "./components/header/header.component";
import Footer00 from "./components/footer/footer00.component";
import ScrollToTop from "./components/scrollToTop/scrollToTop.component";
import ErrorBoundary from "./components/errorHandlers/ErrorBoundary.component";
import SEO from "./components/seo/SEO.component";
import GoogleAnalytics from "./components/analytics/GoogleAnalytics.component";

// Lazy load route components for code splitting
const Home = lazy(() => import("./pages/home/home.page"));
const About = lazy(() => import("./pages/about/about.page"));
// const Testimonials = lazy(() => import("./pages/testimonials/testimonials.page")); // Hidden for now, may be added later
const ContactUs = lazy(() => import("./pages/contact/contact.page"));
const FeaturedProducts = lazy(() => import("./pages/FeaturedProducts/FeaturedProducts.page"));
const Products = lazy(() => import("./pages/products/products.page"));
const Category = lazy(() => import("./pages/products/categories.page"));
const Product = lazy(() => import("./pages/product/product.page"));
const Services = lazy(() => import("./pages/services/services.page"));
const Blogs = lazy(() => import("./pages/blogs/blogs.page"));
const NotFoundPage = lazy(() => import("./components/errorHandlers/notFoundPage.component"));

// Loading fallback component
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '50vh',
    fontSize: '18px',
    color: '#0090c4'
  }}>
    Loading...
  </div>
);

function App() {
  return (
    <Router>
      <ErrorBoundary>
        <SEO />
        <GoogleAnalytics />
        <header>
          <Header />
        </header>
        <main id="main-content">
          <div className="" style={{ zIndex: "99", position: "rel" }}>
            <ScrollToTop />
            <Suspense fallback={<LoadingFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                {/* <Route path="/testimonials" element={<Testimonials />} /> */}
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:category" element={<Category />} />
                <Route path="/product/:productName" element={<Product />} />
                <Route path="/services" element={<Services />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </div>
        </main>
        <footer>
          <Footer00 />
        </footer>
      </ErrorBoundary>
    </Router>
  );
}

export default App;
